import { type FunctionComponent } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";

import type { hamburgerMenuMagazinesStyleTopStoriesQuery } from "scmp-app/queries/__generated__/hamburgerMenuMagazinesStyleTopStoriesQuery.graphql";

import {
  Container,
  LatestStory,
  SectionNameText,
  StyledBaseImage,
  StyledEntityLink,
} from "./styles";

type Props = {
  className?: string;
  onNavigate?: () => void;
};
export const HamburgerMenuMagazinesStyleTopStories: FunctionComponent<Props> = ({
  className,
  onNavigate,
}) => {
  const data = useLazyLoadQuery<hamburgerMenuMagazinesStyleTopStoriesQuery>(
    graphql`
      query hamburgerMenuMagazinesStyleTopStoriesQuery {
        queue(filter: { name: "scmp_pwa_oneline_menu_style" }) {
          items(first: 6) {
            edges {
              node {
                ... on Section {
                  entityId
                  name
                  image(filter: { type: LOGO }) {
                    url
                  }
                }
                ...entityLink
              }
            }
          }
        }
      }
    `,
    {},
  );

  const [latestStoryNodeReference, ...storiesNodeReference] =
    data?.queue?.items?.edges.map(edge => edge.node) ?? [];

  if (!latestStoryNodeReference) return null;

  return (
    <Container className={className}>
      <StyledEntityLink onNavigate={onNavigate} reference={latestStoryNodeReference}>
        <LatestStory />
      </StyledEntityLink>
      {storiesNodeReference.map(reference => (
        <StyledEntityLink key={reference.entityId} onNavigate={onNavigate} reference={reference}>
          {reference.image?.url ? (
            <StyledBaseImage
              $aspectRatio="auto"
              $objectFit="cover"
              alt={reference.name}
              lazyload
              src={reference.image?.url}
            />
          ) : (
            <SectionNameText>{reference.name}</SectionNameText>
          )}
        </StyledEntityLink>
      ))}
    </Container>
  );
};
